<template>
  <td v-if="tx && tx.additional && tx.additional.minting"
      class="table__cell table__cell--arrow">
    <div class="table__cell--arrow-minting" title="Minting Transaction"></div>
  </td>
  <td v-else class="table__cell table__cell--arrow">
    <div class="table__cell--arrow-usual" title="Normal Transaction">   </div>
  </td>
</template>

<script>
export default {
  name: 'IArrow',
  props: {
    tx: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/IArrow.vue